import  { useMyAccessProfileV2 } from "../apis/tryst/get-my-access-profile";

export function useDoctorStaffCheck() {
  const { data: myAccessProfile } = useMyAccessProfileV2();
  const isDoc = myAccessProfile?.loginmeta?.role === "DOCTOR";

  return {
    isStaff: !isDoc,
    isDoctorOnly: isDoc,
  };
}
